module.exports = __webpack_public_path__ + "static/img/bg_four.8ab4e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diagnosis/bg_four.png
// module id = 3RVG
// module chunks = 3